/* Component Dependencies */
var headingTemplate = require('templates/heading.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'heading',
  template: {
    'heading': headingTemplate
  }
});
